import Vue from 'vue'
const state = {}
  // getters
const getters = {
	getBankAccount: state => {	
        return state.bankAccount;
    }
}  // actions
const actions = {   //异步
    getBankAccount({commit},arg) { // commit 提交；name即为点击后传递过来的参数
    	commit ('getBankAccount', arg);
    	
	}
}// mutations
const mutations = {
    getBankAccount (state, arg) {    	
    	Vue.set(state, "bankAccount", arg); //设置属性需要使用vue.set 才能触发 getters
    }
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/admitBankAccount.js